module.exports = __webpack_public_path__ + "img/share.4ee91b2a.svg";